import React, { Component } from 'react';
import './hazard-options.css';
import { BackButton, ProTipButton } from '../buttons';

class HazardOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            secondaryOptions: null,
        };
    }

    handleSecondaryOptions(secondaryOptions) {
        this.setState({ secondaryOptions: secondaryOptions });
    }

    clearOptions() {
        this.setState({ secondaryOptions: null });
    }

    render() {
        const options = this.state.secondaryOptions || this.props.hazard.options;

        return (
            <div className="hazard-options">
                <div className="container">
                    {this.props.hazard.protip && (
                        <ProTipButton
                            toggleTip={this.props.toggleTip}
                            title={`Protip about  ${this.props.hazard.label}`}
                            data={this.props.hazard.protip}
                        />
                    )}
                    <h3>{this.props.hazard.copy}</h3>
                    {<this.props.hazard.IconComponent />}
                    <h2>{this.props.hazard.label}</h2>
                    <BackButton
                        onClick={
                            this.state.secondaryOptions
                                ? this.clearOptions.bind(this)
                                : this.props.back
                        }
                    />
                </div>
                <div className="hazard-options-list">
                    {options.map((option, index) => {
                        return (
                            <div
                                className="hazard-option"
                                key={`option_${index}`}
                                onClick={() => {
                                    if (option.options) {
                                        this.handleSecondaryOptions(option.options);
                                    } else {
                                        this.props.showOutcome(option.outcome);
                                    }
                                }}
                            >
                                {option.option}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default HazardOptions;



// WEBPACK FOOTER //
// ./src/components/hazard-options/hazard-options.js